export class Product {
    packageValidityNumber: number;
    packageValidityUnits: string;
    packageSizeNumber: number;
    packageSizeUnits: string;
    packageGrossPrice: string;
    packageCurrencyCode: string;
    packageCode: string;
}
